/**
 * Plantilla del ANEXO 5 (Balance General Condensado). Cada celda: ph = placeholder
 * (titulo/subtitulo/cooperativa/fecha), k='v' valor fijo, k='f' fórmula, k='lk' monto
 * por código (con signo). Estilo en `s`, ver ANEXO5_ESTILOS.
 */

export interface EstiloA5 {
  font: { name: string; size: number; bold?: boolean; color?: string };
  fill?: string;
  border?: { t?: string; b?: string; l?: string; r?: string };
  numFmt?: string;
  align?: { h?: string; v?: string; wrap?: boolean; shrinkToFit?: boolean };
}

export interface CeldaAnexo5 {
  ref: string;
  ph?: 'titulo' | 'subtitulo' | 'cooperativa' | 'fecha';
  k?: 'v' | 'f' | 'lk';
  v?: string;
  f?: string;
  code?: string;
  sign?: number;
  s: string;
}

// Anchos de columna (A:L), tomados del formato oficial.
export const ANEXO5_COLS: { [col: string]: number } = {
  A: 47.88,
  B: 9.63,
  C: 14.38,
  D: 23.25,
  E: 9.0,
  F: 25.88,
  G: 44.75,
  H: 15.88,
  I: 15.75,
  J: 22.38,
  K: 6.25,
  L: 30.5,
};

// Celdas fusionadas: título, subtítulo y fecha de información.
export const ANEXO5_MERGES: string[] = [
  "A2:L2",
  "A4:L4",
  "A7:F7",
  "G7:L7",
  "A10:F10",
  "G10:L10",
];

// Catálogo de estilos (fuente, relleno, bordes, formato, alineación) usados en la plantilla.
export const ANEXO5_ESTILOS: { [key: string]: EstiloA5 } = {
  e0: { font: { name: "Aptos Narrow", size: 16.0 }, align: { h: "left" } },
  e1: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, numFmt: "#,##0.00", align: { h: "right" } },
  e2: { font: { name: "Aptos Narrow", size: 16.0 }, numFmt: "#,##0.00", align: { h: "right" } },
  e3: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, fill: "FFE7E6E6", border: { t: "thin", b: "thin", l: "thin", r: "thin" }, align: { h: "center", v: "center" } },
  e4: { font: { name: "Arial", size: 10.0, color: "FF000000" }, border: { t: "thin", b: "thin" } },
  e5: { font: { name: "Arial", size: 10.0, color: "FF000000" }, border: { t: "thin", b: "thin", r: "thin" } },
  e6: { font: { name: "Arial", size: 16.0, bold: true }, border: { t: "thin", b: "thin", l: "thin", r: "thin" }, align: { h: "center", v: "center" } },
  e7: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, align: { h: "right" } },
  e8: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin", b: "thin" }, align: { h: "left", v: "center" } },
  e9: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin", b: "thin" }, numFmt: "dd/mmmm/yyyy", align: { h: "left", v: "center" } },
  e10: { font: { name: "Aptos Narrow", size: 16.0, color: "FF7F7F7F" }, align: { v: "center" } },
  e11: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, fill: "FFAEABAB", border: { t: "thin", l: "thin", r: "thin" }, align: { h: "center", v: "center", wrap: true } },
  e12: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin", l: "thin", r: "thin" }, align: { h: "left" } },
  e13: { font: { name: "Aptos Narrow", size: 16.0, color: "FFBFBFBF" }, border: { l: "thin", r: "thin" }, align: { h: "left" } },
  e14: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { t: "thin", l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e15: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin", l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e16: { font: { name: "Aptos Narrow", size: 16.0, color: "FFBFBFBF" }, border: { t: "thin", l: "thin", r: "thin" }, align: { h: "left" } },
  e17: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin", l: "thin" }, align: { h: "left" } },
  e18: { font: { name: "Aptos Narrow", size: 16.0, color: "FFBFBFBF" }, border: { t: "thin" }, align: { h: "left" } },
  e19: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { t: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e20: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e21: { font: { name: "Aptos Narrow", size: 16.0 }, border: { t: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e22: { font: { name: "Aptos Narrow", size: 16.0 }, border: { l: "thin", r: "thin" }, align: { h: "left" } },
  e23: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e24: { font: { name: "Aptos Narrow", size: 16.0 }, border: { l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e25: { font: { name: "Aptos Narrow", size: 16.0 }, border: { l: "thin" }, align: { h: "left" } },
  e26: { font: { name: "Aptos Narrow", size: 16.0, color: "FFBFBFBF" }, align: { h: "left" } },
  e27: { font: { name: "Aptos Narrow", size: 16.0 }, border: { r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e28: { font: { name: "Aptos Narrow", size: 16.0 }, border: { b: "thin", l: "thin", r: "thin" }, align: { h: "left" } },
  e29: { font: { name: "Aptos Narrow", size: 16.0, color: "FFBFBFBF" }, border: { b: "thin", l: "thin", r: "thin" }, align: { h: "left" } },
  e30: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { b: "thin", l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e31: { font: { name: "Aptos Narrow", size: 16.0 }, border: { b: "thin", l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e32: { font: { name: "Aptos Narrow", size: 16.0 }, border: { b: "thin", l: "thin" }, align: { h: "left" } },
  e33: { font: { name: "Aptos Narrow", size: 16.0, color: "FFBFBFBF" }, border: { b: "thin" }, align: { h: "left" } },
  e34: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { b: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e35: { font: { name: "Aptos Narrow", size: 16.0 }, border: { b: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e36: { font: { name: "Aptos Narrow", size: 16.0 }, border: { b: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e37: { font: { name: "Arial", size: 16.0, bold: true }, fill: "FFAEABAB", border: { t: "thin", l: "thin", r: "thin" }, align: { h: "center", v: "center" } },
  e38: { font: { name: "Aptos Narrow", size: 16.0, bold: true, color: "FFAEABAB" }, fill: "FFAEABAB", border: { t: "thin", l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right", v: "center" } },
  e39: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, fill: "FFAEABAB", border: { t: "thin", l: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right", v: "center" } },
  e40: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { b: "thin", l: "thin" }, align: { h: "left" } },
  e41: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { b: "thin", r: "thin" }, numFmt: "#,##0.00", align: { h: "right" } },
  e42: { font: { name: "Aptos Narrow", size: 16.0, bold: true }, border: { l: "thin" }, align: { h: "left" } },
  e43: { font: { name: "Aptos Narrow", size: 16.0 }, border: { b: "thin" }, align: { h: "left" } },
};

// Volcado celda por celda de la plantilla oficial (A1:L103).
export const ANEXO5_CELDAS: CeldaAnexo5[] = [
  { ref: "B1", k: 'v', v: "", s: "e0" },
  { ref: "C1", k: 'v', v: "", s: "e1" },
  { ref: "D1", k: 'v', v: "", s: "e2" },
  { ref: "E1", k: 'v', v: "", s: "e0" },
  { ref: "F1", k: 'v', v: "", s: "e2" },
  { ref: "G1", k: 'v', v: "", s: "e0" },
  { ref: "H1", k: 'v', v: "", s: "e0" },
  { ref: "I1", k: 'v', v: "", s: "e1" },
  { ref: "J1", k: 'v', v: "", s: "e2" },
  { ref: "K1", k: 'v', v: "", s: "e0" },
  { ref: "L1", k: 'v', v: "", s: "e2" },
  { ref: "A2", ph: "titulo", s: "e3" },
  { ref: "B2", k: 'v', v: "", s: "e4" },
  { ref: "C2", k: 'v', v: "", s: "e4" },
  { ref: "D2", k: 'v', v: "", s: "e4" },
  { ref: "E2", k: 'v', v: "", s: "e4" },
  { ref: "F2", k: 'v', v: "", s: "e4" },
  { ref: "G2", k: 'v', v: "", s: "e4" },
  { ref: "H2", k: 'v', v: "", s: "e4" },
  { ref: "I2", k: 'v', v: "", s: "e4" },
  { ref: "J2", k: 'v', v: "", s: "e4" },
  { ref: "K2", k: 'v', v: "", s: "e4" },
  { ref: "L2", k: 'v', v: "", s: "e5" },
  { ref: "A4", ph: "subtitulo", s: "e6" },
  { ref: "B4", k: 'v', v: "", s: "e4" },
  { ref: "C4", k: 'v', v: "", s: "e4" },
  { ref: "D4", k: 'v', v: "", s: "e4" },
  { ref: "E4", k: 'v', v: "", s: "e4" },
  { ref: "F4", k: 'v', v: "", s: "e4" },
  { ref: "G4", k: 'v', v: "", s: "e4" },
  { ref: "H4", k: 'v', v: "", s: "e4" },
  { ref: "I4", k: 'v', v: "", s: "e4" },
  { ref: "J4", k: 'v', v: "", s: "e4" },
  { ref: "K4", k: 'v', v: "", s: "e4" },
  { ref: "L4", k: 'v', v: "", s: "e5" },
  { ref: "A7", k: 'v', v: "COOPERATIVA:", s: "e7" },
  { ref: "G7", ph: "cooperativa", s: "e8" },
  { ref: "H7", k: 'v', v: "", s: "e8" },
  { ref: "I7", k: 'v', v: "", s: "e8" },
  { ref: "J7", k: 'v', v: "", s: "e8" },
  { ref: "K7", k: 'v', v: "", s: "e8" },
  { ref: "L7", k: 'v', v: "", s: "e8" },
  { ref: "F8", k: 'v', v: "", s: "e7" },
  { ref: "G8", k: 'v', v: "", s: "e0" },
  { ref: "L8", k: 'v', v: "", s: "e0" },
  { ref: "F9", k: 'v', v: "", s: "e7" },
  { ref: "G9", k: 'v', v: "", s: "e7" },
  { ref: "H9", k: 'v', v: "", s: "e7" },
  { ref: "I9", k: 'v', v: "", s: "e7" },
  { ref: "J9", k: 'v', v: "", s: "e7" },
  { ref: "K9", k: 'v', v: "", s: "e7" },
  { ref: "L9", k: 'v', v: "", s: "e7" },
  { ref: "B10", k: 'v', v: "", s: "e0" },
  { ref: "C10", k: 'v', v: "", s: "e1" },
  { ref: "D10", k: 'v', v: "", s: "e2" },
  { ref: "E10", k: 'v', v: "", s: "e0" },
  { ref: "A10", k: 'v', v: "FECHA INFORMACIÓN:", s: "e7" },
  { ref: "G10", ph: "fecha", s: "e9" },
  { ref: "H10", k: 'v', v: "", s: "e4" },
  { ref: "I10", k: 'v', v: "", s: "e4" },
  { ref: "J10", k: 'v', v: "", s: "e4" },
  { ref: "K10", k: 'v', v: "", s: "e4" },
  { ref: "L10", k: 'v', v: "", s: "e4" },
  { ref: "A11", k: 'v', v: "(Cifras en Lempiras)", s: "e10" },
  { ref: "B11", k: 'v', v: "", s: "e0" },
  { ref: "C11", k: 'v', v: "", s: "e1" },
  { ref: "D11", k: 'v', v: "", s: "e2" },
  { ref: "E11", k: 'v', v: "", s: "e0" },
  { ref: "F11", k: 'v', v: "", s: "e2" },
  { ref: "G11", k: 'v', v: "", s: "e0" },
  { ref: "H11", k: 'v', v: "", s: "e0" },
  { ref: "I11", k: 'v', v: "", s: "e1" },
  { ref: "J11", k: 'v', v: "", s: "e2" },
  { ref: "K11", k: 'v', v: "", s: "e0" },
  { ref: "L11", k: 'v', v: "", s: "e2" },
  { ref: "A12", k: 'v', v: "ACTIVO", s: "e11" },
  { ref: "B12", k: 'v', v: "CTA", s: "e11" },
  { ref: "C12", k: 'v', v: "TOTAL", s: "e11" },
  { ref: "D12", k: 'v', v: "MONEDA NACIONAL", s: "e11" },
  { ref: "E12", k: 'v', v: "CTA", s: "e11" },
  { ref: "F12", k: 'v', v: "MONEDA EXTRANJERA", s: "e11" },
  { ref: "G12", k: 'v', v: "PASIVO", s: "e11" },
  { ref: "H12", k: 'v', v: "CTA", s: "e11" },
  { ref: "I12", k: 'v', v: "TOTAL", s: "e11" },
  { ref: "J12", k: 'v', v: "MONEDA NACIONAL", s: "e11" },
  { ref: "K12", k: 'v', v: "CTA", s: "e11" },
  { ref: "L12", k: 'v', v: "MONEDA EXTRANJERA", s: "e11" },
  { ref: "A13", k: 'v', v: "DISPONIBILIDADES", s: "e12" },
  { ref: "B13", k: 'v', v: "101", s: "e13" },
  { ref: "C13", k: 'f', f: "SUM(D14:D16)+SUM(F14:F16)", s: "e14" },
  { ref: "D13", k: 'v', v: "", s: "e15" },
  { ref: "E13", k: 'v', v: "", s: "e16" },
  { ref: "F13", k: 'v', v: "", s: "e15" },
  { ref: "G13", k: 'v', v: "EXIGIBILIDADES INMEDIATAS", s: "e17" },
  { ref: "H13", k: 'v', v: "201", s: "e18" },
  { ref: "I13", k: 'lk', code: "201", s: "e19" },
  { ref: "J13", k: 'v', v: "", s: "e20" },
  { ref: "K13", k: 'v', v: "", s: "e18" },
  { ref: "L13", k: 'v', v: "", s: "e21" },
  { ref: "A14", k: 'v', v: "CAJA", s: "e22" },
  { ref: "B14", k: 'v', v: "101101", s: "e13" },
  { ref: "C14", k: 'v', v: "", s: "e23" },
  { ref: "D14", k: 'lk', code: "101101", s: "e24" },
  { ref: "E14", k: 'v', v: "101201", s: "e13" },
  { ref: "F14", k: 'lk', code: "101201", s: "e24" },
  { ref: "G14", k: 'v', v: "DOCUMENTOS Y ORDENES DE PAGO", s: "e25" },
  { ref: "H14", k: 'v', v: "201107", s: "e26" },
  { ref: "I14", k: 'v', v: "", s: "e1" },
  { ref: "J14", k: 'lk', code: "201107", s: "e2" },
  { ref: "K14", k: 'v', v: "201207", s: "e26" },
  { ref: "L14", k: 'lk', code: "201207", s: "e27" },
  { ref: "A15", k: 'v', v: "DEPÓSITOS EN EL BANCO CENTRAL", s: "e22" },
  { ref: "B15", k: 'v', v: "101102", s: "e13" },
  { ref: "C15", k: 'v', v: "", s: "e23" },
  { ref: "D15", k: 'lk', code: "101102", s: "e24" },
  { ref: "E15", k: 'v', v: "101202", s: "e13" },
  { ref: "F15", k: 'lk', code: "101202", s: "e24" },
  { ref: "G15", k: 'v', v: "OBLIGACIONES POR ADMINISTRACIÓN", s: "e25" },
  { ref: "H15", k: 'v', v: "201108", s: "e26" },
  { ref: "I15", k: 'v', v: "", s: "e1" },
  { ref: "J15", k: 'lk', code: "201108", s: "e2" },
  { ref: "K15", k: 'v', v: "201208", s: "e26" },
  { ref: "L15", k: 'lk', code: "201208", s: "e27" },
  { ref: "A16", k: 'v', v: "DEPÓSITOS EN BANCOS DEL INTERIOR", s: "e22" },
  { ref: "B16", k: 'v', v: "101103", s: "e13" },
  { ref: "C16", k: 'v', v: "", s: "e23" },
  { ref: "D16", k: 'lk', code: "101103", s: "e24" },
  { ref: "E16", k: 'v', v: "101203", s: "e13" },
  { ref: "F16", k: 'lk', code: "101203", s: "e24" },
  { ref: "G16", k: 'v', v: "ACREEDORES VARIOS", s: "e25" },
  { ref: "H16", k: 'v', v: "201109", s: "e26" },
  { ref: "I16", k: 'v', v: "", s: "e1" },
  { ref: "J16", k: 'lk', code: "201109", s: "e2" },
  { ref: "K16", k: 'v', v: "201209", s: "e26" },
  { ref: "L16", k: 'lk', code: "201209", s: "e27" },
  { ref: "A17", k: 'v', v: "INVERSIONES", s: "e22" },
  { ref: "B17", k: 'v', v: "102", s: "e13" },
  { ref: "C17", k: 'f', f: "SUM(D18:D20)+SUM(F18:F20)", s: "e23" },
  { ref: "D17", k: 'v', v: "", s: "e24" },
  { ref: "E17", k: 'v', v: "", s: "e13" },
  { ref: "F17", k: 'lk', code: "", s: "e24" },
  { ref: "G17", k: 'v', v: "EXCEDENTES POR DISTRIBUIR", s: "e25" },
  { ref: "H17", k: 'v', v: "201110", s: "e26" },
  { ref: "I17", k: 'v', v: "", s: "e1" },
  { ref: "J17", k: 'lk', code: "201110", s: "e2" },
  { ref: "K17", k: 'v', v: "", s: "e26" },
  { ref: "L17", k: 'lk', code: "", s: "e27" },
  { ref: "A18", k: 'v', v: "INVERSIONES EN VALORES", s: "e22" },
  { ref: "B18", k: 'v', v: "102101", s: "e13" },
  { ref: "C18", k: 'v', v: "", s: "e23" },
  { ref: "D18", k: 'lk', code: "102101", s: "e24" },
  { ref: "E18", k: 'v', v: "102201", s: "e13" },
  { ref: "F18", k: 'lk', code: "102201", s: "e24" },
  { ref: "G18", k: 'v', v: "INTERESES POR PAGAR", s: "e25" },
  { ref: "H18", k: 'v', v: "201112", s: "e26" },
  { ref: "I18", k: 'v', v: "", s: "e1" },
  { ref: "J18", k: 'lk', code: "201112", s: "e2" },
  { ref: "K18", k: 'v', v: "201212", s: "e26" },
  { ref: "L18", k: 'lk', code: "201212", s: "e27" },
  { ref: "A19", k: 'v', v: "AMORTIZACIÓN ACUMULADA DE INVERSIONES", s: "e22" },
  { ref: "B19", k: 'v', v: "207103", s: "e13" },
  { ref: "C19", k: 'v', v: "", s: "e23" },
  { ref: "D19", k: 'lk', code: "207103", sign: -1, s: "e24" },
  { ref: "E19", k: 'v', v: "", s: "e13" },
  { ref: "F19", k: 'lk', code: "", s: "e24" },
  { ref: "G19", k: 'v', v: "COMISIONES POR PAGAR", s: "e25" },
  { ref: "H19", k: 'v', v: "201113", s: "e26" },
  { ref: "I19", k: 'v', v: "", s: "e1" },
  { ref: "J19", k: 'lk', code: "201113", s: "e2" },
  { ref: "K19", k: 'v', v: "201213", s: "e26" },
  { ref: "L19", k: 'lk', code: "201213", s: "e27" },
  { ref: "A20", k: 'v', v: "INVERSIONES EN FONDOS ESPECIALES", s: "e22" },
  { ref: "B20", k: 'v', v: "102102", s: "e13" },
  { ref: "C20", k: 'v', v: "", s: "e23" },
  { ref: "D20", k: 'lk', code: "102102", s: "e24" },
  { ref: "E20", k: 'v', v: "102202", s: "e13" },
  { ref: "F20", k: 'lk', code: "102202", s: "e24" },
  { ref: "G20", k: 'v', v: "DOCUMENTOS POR PAGAR", s: "e25" },
  { ref: "H20", k: 'v', v: "201120", s: "e26" },
  { ref: "I20", k: 'v', v: "", s: "e1" },
  { ref: "J20", k: 'lk', code: "201120", s: "e2" },
  { ref: "K20", k: 'v', v: "201220", s: "e26" },
  { ref: "L20", k: 'lk', code: "201220", s: "e27" },
  { ref: "A21", k: 'v', v: "", s: "e22" },
  { ref: "B21", k: 'v', v: "", s: "e13" },
  { ref: "C21", k: 'v', v: "", s: "e23" },
  { ref: "D21", k: 'lk', code: "", s: "e24" },
  { ref: "E21", k: 'v', v: "", s: "e13" },
  { ref: "F21", k: 'lk', code: "", s: "e24" },
  { ref: "G21", k: 'v', v: "CUENTAS POR PAGAR", s: "e25" },
  { ref: "H21", k: 'v', v: "201121", s: "e26" },
  { ref: "I21", k: 'v', v: "", s: "e1" },
  { ref: "J21", k: 'lk', code: "201121", s: "e2" },
  { ref: "K21", k: 'v', v: "201221", s: "e26" },
  { ref: "L21", k: 'lk', code: "201221", s: "e27" },
  { ref: "A22", k: 'v', v: "PRÉSTAMOS, DESCUENTOS Y NEGOCIACIONES", s: "e22" },
  { ref: "B22", k: 'v', v: "103", s: "e22" },
  { ref: "C22", k: 'f', f: "SUM(D23:D27)+SUM(F23:F27)", s: "e23" },
  { ref: "D22", k: 'v', v: "", s: "e24" },
  { ref: "E22", k: 'v', v: "", s: "e13" },
  { ref: "F22", k: 'lk', code: "", s: "e24" },
  { ref: "G22", k: 'v', v: "", s: "e25" },
  { ref: "H22", k: 'v', v: "", s: "e26" },
  { ref: "I22", k: 'v', v: "", s: "e1" },
  { ref: "J22", k: 'lk', code: "", s: "e2" },
  { ref: "K22", k: 'v', v: "", s: "e26" },
  { ref: "L22", k: 'lk', code: "", s: "e27" },
  { ref: "A23", k: 'v', v: "VIGENTES", s: "e22" },
  { ref: "B23", k: 'v', v: "103101", s: "e13" },
  { ref: "C23", k: 'v', v: "", s: "e23" },
  { ref: "D23", k: 'lk', code: "103101", s: "e24" },
  { ref: "E23", k: 'v', v: "103201", s: "e13" },
  { ref: "F23", k: 'lk', code: "103201", s: "e24" },
  { ref: "G23", k: 'v', v: "EXIGIBILIDADES POR DEPÓSITOS", s: "e25" },
  { ref: "H23", k: 'v', v: "202", s: "e26" },
  { ref: "I23", k: 'lk', code: "202", s: "e1" },
  { ref: "J23", k: 'v', v: "", s: "e2" },
  { ref: "K23", k: 'v', v: "", s: "e26" },
  { ref: "L23", k: 'lk', code: "", s: "e27" },
  { ref: "A24", k: 'v', v: "ATRASADOS", s: "e22" },
  { ref: "B24", k: 'v', v: "103102", s: "e13" },
  { ref: "C24", k: 'v', v: "", s: "e23" },
  { ref: "D24", k: 'lk', code: "103102", s: "e24" },
  { ref: "E24", k: 'v', v: "103202", s: "e13" },
  { ref: "F24", k: 'lk', code: "103202", s: "e24" },
  { ref: "G24", k: 'v', v: "DEPÓSITOS DE AHORRO", s: "e25" },
  { ref: "H24", k: 'v', v: "202101", s: "e26" },
  { ref: "I24", k: 'v', v: "", s: "e1" },
  { ref: "J24", k: 'lk', code: "202101", s: "e2" },
  { ref: "K24", k: 'v', v: "202201", s: "e26" },
  { ref: "L24", k: 'lk', code: "202201", s: "e27" },
  { ref: "A25", k: 'v', v: "VENCIDOS", s: "e22" },
  { ref: "B25", k: 'v', v: "103103", s: "e13" },
  { ref: "C25", k: 'v', v: "", s: "e23" },
  { ref: "D25", k: 'lk', code: "103103", s: "e24" },
  { ref: "E25", k: 'v', v: "103203", s: "e13" },
  { ref: "F25", k: 'lk', code: "103203", s: "e24" },
  { ref: "G25", k: 'v', v: "DEPÓSITOS A PLAZO", s: "e25" },
  { ref: "H25", k: 'v', v: "202103", s: "e26" },
  { ref: "I25", k: 'v', v: "", s: "e1" },
  { ref: "J25", k: 'lk', code: "202103", s: "e2" },
  { ref: "K25", k: 'v', v: "202203", s: "e26" },
  { ref: "L25", k: 'lk', code: "202203", s: "e27" },
  { ref: "A26", k: 'v', v: "EN EJECUCIÓN JUDICIAL", s: "e22" },
  { ref: "B26", k: 'v', v: "103104", s: "e13" },
  { ref: "C26", k: 'v', v: "", s: "e23" },
  { ref: "D26", k: 'lk', code: "103104", s: "e24" },
  { ref: "E26", k: 'v', v: "103204", s: "e13" },
  { ref: "F26", k: 'lk', code: "103204", s: "e24" },
  { ref: "G26", k: 'v', v: "", s: "e25" },
  { ref: "H26", k: 'v', v: "", s: "e26" },
  { ref: "I26", k: 'v', v: "", s: "e1" },
  { ref: "J26", k: 'lk', code: "", s: "e2" },
  { ref: "K26", k: 'v', v: "", s: "e26" },
  { ref: "L26", k: 'lk', code: "", s: "e27" },
  { ref: "A27", k: 'v', v: "PROVISIÓN PARA CRÉDITOS DUDOSOS", s: "e22" },
  { ref: "B27", k: 'v', v: "207101", s: "e13" },
  { ref: "C27", k: 'v', v: "", s: "e23" },
  { ref: "D27", k: 'lk', code: "207101", sign: -1, s: "e24" },
  { ref: "E27", k: 'v', v: "", s: "e13" },
  { ref: "F27", k: 'lk', code: "", s: "e24" },
  { ref: "G27", k: 'v', v: "OTRAS EXIGIBILIDADES", s: "e25" },
  { ref: "H27", k: 'v', v: "203", s: "e26" },
  { ref: "I27", k: 'lk', code: "203", s: "e1" },
  { ref: "J27", k: 'v', v: "", s: "e2" },
  { ref: "K27", k: 'v', v: "", s: "e26" },
  { ref: "L27", k: 'lk', code: "", s: "e27" },
  { ref: "A28", k: 'v', v: "", s: "e22" },
  { ref: "B28", k: 'v', v: "", s: "e13" },
  { ref: "C28", k: 'v', v: "", s: "e23" },
  { ref: "D28", k: 'lk', code: "", s: "e24" },
  { ref: "E28", k: 'v', v: "", s: "e13" },
  { ref: "F28", k: 'lk', code: "", s: "e24" },
  { ref: "G28", k: 'v', v: "CHEQUES EN CIRCULACIÓN", s: "e25" },
  { ref: "H28", k: 'v', v: "203103", s: "e26" },
  { ref: "I28", k: 'v', v: "", s: "e1" },
  { ref: "J28", k: 'lk', code: "203103", s: "e2" },
  { ref: "K28", k: 'v', v: "203203", s: "e26" },
  { ref: "L28", k: 'lk', code: "203203", s: "e27" },
  { ref: "A29", k: 'v', v: "CUENTAS Y DOCUMENTOS POR COBRAR", s: "e22" },
  { ref: "B29", k: 'v', v: "104", s: "e22" },
  { ref: "C29", k: 'f', f: "SUM(D30:D36)+SUM(F30:F36)", s: "e23" },
  { ref: "D29", k: 'v', v: "", s: "e24" },
  { ref: "E29", k: 'v', v: "", s: "e13" },
  { ref: "F29", k: 'lk', code: "", s: "e24" },
  { ref: "G29", k: 'v', v: "", s: "e25" },
  { ref: "H29", k: 'v', v: "", s: "e26" },
  { ref: "I29", k: 'v', v: "", s: "e1" },
  { ref: "J29", k: 'lk', code: "", s: "e2" },
  { ref: "K29", k: 'v', v: "", s: "e26" },
  { ref: "L29", k: 'lk', code: "", s: "e27" },
  { ref: "A30", k: 'v', v: "DEUDORES VARIOS", s: "e22" },
  { ref: "B30", k: 'v', v: "104101", s: "e13" },
  { ref: "C30", k: 'v', v: "", s: "e23" },
  { ref: "D30", k: 'lk', code: "104101", s: "e24" },
  { ref: "E30", k: 'v', v: "104201", s: "e13" },
  { ref: "F30", k: 'lk', code: "104201", s: "e24" },
  { ref: "G30", k: 'v', v: "OBLIGACIONES BANCARIAS", s: "e25" },
  { ref: "H30", k: 'v', v: "204", s: "e26" },
  { ref: "I30", k: 'lk', code: "204", s: "e1" },
  { ref: "J30", k: 'v', v: "", s: "e2" },
  { ref: "K30", k: 'v', v: "", s: "e26" },
  { ref: "L30", k: 'lk', code: "", s: "e27" },
  { ref: "A31", k: 'v', v: "PROVISION PARA CUENTAS Y DOCUMENTOS POR COBRAR", s: "e22" },
  { ref: "B31", k: 'v', v: "207112", s: "e13" },
  { ref: "C31", k: 'v', v: "", s: "e23" },
  { ref: "D31", k: 'lk', code: "207112", sign: -1, s: "e24" },
  { ref: "E31", k: 'v', v: "", s: "e13" },
  { ref: "F31", k: 'lk', code: "", s: "e24" },
  { ref: "G31", k: 'v', v: "OBLIGACIONES POR PRÉSTAMOS REDESCONTADOS", s: "e25" },
  { ref: "H31", k: 'v', v: "204101", s: "e26" },
  { ref: "I31", k: 'v', v: "", s: "e1" },
  { ref: "J31", k: 'lk', code: "204101", s: "e2" },
  { ref: "K31", k: 'v', v: "204201", s: "e26" },
  { ref: "L31", k: 'lk', code: "204201", s: "e27" },
  { ref: "A32", k: 'v', v: "COMISIONES POR COBRAR", s: "e22" },
  { ref: "B32", k: 'v', v: "104103", s: "e13" },
  { ref: "C32", k: 'v', v: "", s: "e23" },
  { ref: "D32", k: 'lk', code: "104103", s: "e24" },
  { ref: "E32", k: 'v', v: "104203", s: "e13" },
  { ref: "F32", k: 'lk', code: "104203", s: "e24" },
  { ref: "G32", k: 'v', v: "CRÉDITOS Y OBLIGACIONES BANCARIAS", s: "e25" },
  { ref: "H32", k: 'v', v: "204102", s: "e26" },
  { ref: "I32", k: 'v', v: "", s: "e1" },
  { ref: "J32", k: 'lk', code: "204102", s: "e2" },
  { ref: "K32", k: 'v', v: "204202", s: "e26" },
  { ref: "L32", k: 'lk', code: "204202", s: "e27" },
  { ref: "A33", k: 'v', v: "INTERESES SOBRE PRÉSTAMOS POR COBRAR", s: "e22" },
  { ref: "B33", k: 'v', v: "104104", s: "e13" },
  { ref: "C33", k: 'v', v: "", s: "e23" },
  { ref: "D33", k: 'lk', code: "104104", s: "e24" },
  { ref: "E33", k: 'v', v: "104204", s: "e13" },
  { ref: "F33", k: 'lk', code: "104204", s: "e24" },
  { ref: "G33", k: 'v', v: "", s: "e25" },
  { ref: "H33", k: 'v', v: "", s: "e26" },
  { ref: "I33", k: 'v', v: "", s: "e1" },
  { ref: "J33", k: 'lk', code: "", s: "e2" },
  { ref: "K33", k: 'v', v: "", s: "e26" },
  { ref: "L33", k: 'lk', code: "", s: "e27" },
  { ref: "A34", k: 'v', v: "PROVISIÓN PARA INTERESES DUDOSOS", s: "e22" },
  { ref: "B34", k: 'v', v: "207102", s: "e13" },
  { ref: "C34", k: 'v', v: "", s: "e23" },
  { ref: "D34", k: 'lk', code: "207102", sign: -1, s: "e24" },
  { ref: "E34", k: 'v', v: "", s: "e13" },
  { ref: "F34", k: 'lk', code: "", s: "e24" },
  { ref: "G34", k: 'v', v: "CRÉDITOS DIFERIDOS", s: "e25" },
  { ref: "H34", k: 'v', v: "206", s: "e26" },
  { ref: "I34", k: 'lk', code: "206", s: "e1" },
  { ref: "J34", k: 'v', v: "", s: "e2" },
  { ref: "K34", k: 'v', v: "", s: "e26" },
  { ref: "L34", k: 'lk', code: "", s: "e27" },
  { ref: "A35", k: 'v', v: "INTERESES Y DIVIDENDOS SOBRE INVERSIONES POR COBRAR", s: "e22" },
  { ref: "B35", k: 'v', v: "104105", s: "e13" },
  { ref: "C35", k: 'v', v: "", s: "e23" },
  { ref: "D35", k: 'lk', code: "104105", s: "e24" },
  { ref: "E35", k: 'v', v: "104205", s: "e13" },
  { ref: "F35", k: 'lk', code: "104205", s: "e24" },
  { ref: "G35", k: 'v', v: "VALORES RECIBIDOS POR ANTICIPADO", s: "e25" },
  { ref: "H35", k: 'v', v: "206101", s: "e26" },
  { ref: "I35", k: 'v', v: "", s: "e1" },
  { ref: "J35", k: 'lk', code: "206101", s: "e2" },
  { ref: "K35", k: 'v', v: "206201", s: "e26" },
  { ref: "L35", k: 'lk', code: "206201", s: "e27" },
  { ref: "A36", k: 'v', v: "DEPÓSITOS EN GARANTIA", s: "e28" },
  { ref: "B36", k: 'v', v: "104107", s: "e29" },
  { ref: "C36", k: 'v', v: "", s: "e30" },
  { ref: "D36", k: 'lk', code: "104107", s: "e31" },
  { ref: "E36", k: 'v', v: "", s: "e29" },
  { ref: "F36", k: 'lk', code: "", s: "e31" },
  { ref: "G36", k: 'v', v: "VALORES PENDIENTES DE APLICACIÓN", s: "e25" },
  { ref: "H36", k: 'v', v: "206102", s: "e26" },
  { ref: "I36", k: 'v', v: "", s: "e1" },
  { ref: "J36", k: 'lk', code: "206102", s: "e2" },
  { ref: "K36", k: 'v', v: "206202", s: "e26" },
  { ref: "L36", k: 'lk', code: "206202", s: "e27" },
  { ref: "A37", k: 'v', v: "", s: "e12" },
  { ref: "B37", k: 'v', v: "", s: "e16" },
  { ref: "C37", k: 'v', v: "", s: "e14" },
  { ref: "D37", k: 'lk', code: "", s: "e15" },
  { ref: "E37", k: 'v', v: "", s: "e16" },
  { ref: "F37", k: 'lk', code: "", s: "e15" },
  { ref: "G37", k: 'v', v: "DESCUENTOS POR DEVENGAR SOBRE INVERSIONES EN VALORES", s: "e25" },
  { ref: "H37", k: 'v', v: "206104", s: "e26" },
  { ref: "I37", k: 'v', v: "", s: "e1" },
  { ref: "J37", k: 'lk', code: "206104", s: "e2" },
  { ref: "K37", k: 'v', v: "206204", s: "e26" },
  { ref: "L37", k: 'lk', code: "206204", s: "e27" },
  { ref: "A38", k: 'v', v: "ACTIVOS EVENTUALES", s: "e22" },
  { ref: "B38", k: 'v', v: "106", s: "e22" },
  { ref: "C38", k: 'f', f: "SUM(D39:D41)", s: "e23" },
  { ref: "D38", k: 'v', v: "", s: "e24" },
  { ref: "E38", k: 'v', v: "", s: "e13" },
  { ref: "F38", k: 'lk', code: "", s: "e24" },
  { ref: "G38", k: 'v', v: "INTERESES PENDIENTES DE COBRO SOBRE PRÉSTAMOS READECUADOS", s: "e25" },
  { ref: "H38", k: 'v', v: "206107", s: "e26" },
  { ref: "I38", k: 'v', v: "", s: "e1" },
  { ref: "J38", k: 'lk', code: "206107", s: "e2" },
  { ref: "K38", k: 'v', v: "206207", s: "e26" },
  { ref: "L38", k: 'lk', code: "206207", s: "e27" },
  { ref: "A39", k: 'v', v: "INMUEBLES", s: "e22" },
  { ref: "B39", k: 'v', v: "106101", s: "e13" },
  { ref: "C39", k: 'v', v: "", s: "e23" },
  { ref: "D39", k: 'lk', code: "106101", s: "e24" },
  { ref: "E39", k: 'v', v: "", s: "e13" },
  { ref: "F39", k: 'lk', code: "", s: "e24" },
  { ref: "G39", k: 'v', v: "", s: "e25" },
  { ref: "H39", k: 'v', v: "", s: "e26" },
  { ref: "I39", k: 'v', v: "", s: "e1" },
  { ref: "J39", k: 'lk', code: "", s: "e2" },
  { ref: "K39", k: 'v', v: "", s: "e26" },
  { ref: "L39", k: 'lk', code: "", s: "e27" },
  { ref: "A40", k: 'v', v: "MUEBLES", s: "e22" },
  { ref: "B40", k: 'v', v: "106102", s: "e13" },
  { ref: "C40", k: 'v', v: "", s: "e23" },
  { ref: "D40", k: 'lk', code: "106102", s: "e24" },
  { ref: "E40", k: 'v', v: "", s: "e13" },
  { ref: "F40", k: 'lk', code: "", s: "e24" },
  { ref: "G40", k: 'v', v: "PROVISIONES EVENTUALES", s: "e25" },
  { ref: "H40", k: 'v', v: "208", s: "e26" },
  { ref: "I40", k: 'lk', code: "208", s: "e1" },
  { ref: "J40", k: 'v', v: "", s: "e2" },
  { ref: "K40", k: 'v', v: "", s: "e26" },
  { ref: "L40", k: 'lk', code: "", s: "e27" },
  { ref: "A41", k: 'v', v: "AMORTIZACIÓN ACUMULADA DE ACTIVOS EVENTUALES", s: "e22" },
  { ref: "B41", k: 'v', v: "207107", s: "e13" },
  { ref: "C41", k: 'v', v: "", s: "e23" },
  { ref: "D41", k: 'lk', code: "207107", sign: -1, s: "e24" },
  { ref: "E41", k: 'v', v: "", s: "e13" },
  { ref: "F41", k: 'lk', code: "", s: "e24" },
  { ref: "G41", k: 'v', v: "PROVISIÓN PARA PRESTACIONES SOCIALES", s: "e25" },
  { ref: "H41", k: 'v', v: "208102", s: "e26" },
  { ref: "I41", k: 'v', v: "", s: "e1" },
  { ref: "J41", k: 'lk', code: "208102", s: "e2" },
  { ref: "K41", k: 'v', v: "", s: "e26" },
  { ref: "L41", k: 'lk', code: "", s: "e27" },
  { ref: "A42", k: 'v', v: "", s: "e22" },
  { ref: "B42", k: 'v', v: "", s: "e13" },
  { ref: "C42", k: 'v', v: "", s: "e23" },
  { ref: "D42", k: 'lk', code: "", s: "e24" },
  { ref: "E42", k: 'v', v: "", s: "e13" },
  { ref: "F42", k: 'lk', code: "", s: "e24" },
  { ref: "G42", k: 'v', v: "PROVISIONES ESPECIALES", s: "e25" },
  { ref: "H42", k: 'v', v: "208103", s: "e26" },
  { ref: "I42", k: 'v', v: "", s: "e1" },
  { ref: "J42", k: 'lk', code: "208103", s: "e2" },
  { ref: "K42", k: 'v', v: "", s: "e26" },
  { ref: "L42", k: 'lk', code: "", s: "e27" },
  { ref: "A43", k: 'v', v: "PROPIEDAD, PLANTA Y EQUIPO", s: "e22" },
  { ref: "B43", k: 'v', v: "107", s: "e22" },
  { ref: "C43", k: 'f', f: "SUM(D44:D53)", s: "e23" },
  { ref: "D43", k: 'v', v: "", s: "e24" },
  { ref: "E43", k: 'v', v: "", s: "e13" },
  { ref: "F43", k: 'lk', code: "", s: "e24" },
  { ref: "G43", k: 'v', v: "", s: "e32" },
  { ref: "H43", k: 'v', v: "", s: "e33" },
  { ref: "I43", k: 'v', v: "", s: "e34" },
  { ref: "J43", k: 'lk', code: "", s: "e35" },
  { ref: "K43", k: 'v', v: "", s: "e33" },
  { ref: "L43", k: 'lk', code: "", s: "e36" },
  { ref: "A44", k: 'v', v: "BIENES RAICES", s: "e22" },
  { ref: "B44", k: 'v', v: "107101", s: "e13" },
  { ref: "C44", k: 'v', v: "", s: "e23" },
  { ref: "D44", k: 'lk', code: "107101", s: "e24" },
  { ref: "E44", k: 'v', v: "", s: "e13" },
  { ref: "F44", k: 'lk', code: "", s: "e24" },
  { ref: "G44", k: 'v', v: "PATRIMONIO", s: "e11" },
  { ref: "H44", k: 'v', v: "", s: "e11" },
  { ref: "I44", k: 'v', v: "", s: "e11" },
  { ref: "J44", k: 'v', v: "", s: "e11" },
  { ref: "K44", k: 'v', v: "", s: "e11" },
  { ref: "L44", k: 'lk', code: "", s: "e11" },
  { ref: "A45", k: 'v', v: "MOBILIARIO Y EQUIPO DE OFICINA", s: "e22" },
  { ref: "B45", k: 'v', v: "107102", s: "e13" },
  { ref: "C45", k: 'v', v: "", s: "e23" },
  { ref: "D45", k: 'lk', code: "107102", s: "e24" },
  { ref: "E45", k: 'v', v: "", s: "e13" },
  { ref: "F45", k: 'lk', code: "", s: "e24" },
  { ref: "G45", k: 'v', v: "PATRIMONIO PRIMARIO", s: "e17" },
  { ref: "H45", k: 'v', v: "301", s: "e18" },
  { ref: "I45", k: 'lk', code: "301", s: "e19" },
  { ref: "J45", k: 'v', v: "", s: "e20" },
  { ref: "K45", k: 'v', v: "", s: "e18" },
  { ref: "L45", k: 'lk', code: "", s: "e21" },
  { ref: "A46", k: 'v', v: "INSTALACIONES", s: "e22" },
  { ref: "B46", k: 'v', v: "107103", s: "e13" },
  { ref: "C46", k: 'v', v: "", s: "e23" },
  { ref: "D46", k: 'lk', code: "107103", s: "e24" },
  { ref: "E46", k: 'v', v: "", s: "e13" },
  { ref: "F46", k: 'lk', code: "", s: "e24" },
  { ref: "G46", k: 'v', v: "APORTACIONES", s: "e25" },
  { ref: "H46", k: 'v', v: "301101", s: "e26" },
  { ref: "I46", k: 'v', v: "", s: "e1" },
  { ref: "J46", k: 'lk', code: "301101", s: "e2" },
  { ref: "K46", k: 'v', v: "", s: "e26" },
  { ref: "L46", k: 'lk', code: "", s: "e27" },
  { ref: "A47", k: 'v', v: "BIENES ARRENDADOS", s: "e22" },
  { ref: "B47", k: 'v', v: "107104", s: "e13" },
  { ref: "C47", k: 'v', v: "", s: "e23" },
  { ref: "D47", k: 'lk', code: "107104", s: "e24" },
  { ref: "E47", k: 'v', v: "", s: "e13" },
  { ref: "F47", k: 'lk', code: "", s: "e24" },
  { ref: "G47", k: 'v', v: "RESERVA LEGAL", s: "e25" },
  { ref: "H47", k: 'v', v: "301103", s: "e26" },
  { ref: "I47", k: 'v', v: "", s: "e1" },
  { ref: "J47", k: 'lk', code: "301103", s: "e2" },
  { ref: "K47", k: 'v', v: "", s: "e26" },
  { ref: "L47", k: 'lk', code: "", s: "e27" },
  { ref: "A48", k: 'v', v: "VEHÍCULOS", s: "e22" },
  { ref: "B48", k: 'v', v: "107105", s: "e13" },
  { ref: "C48", k: 'v', v: "", s: "e23" },
  { ref: "D48", k: 'lk', code: "107105", s: "e24" },
  { ref: "E48", k: 'v', v: "", s: "e13" },
  { ref: "F48", k: 'lk', code: "", s: "e24" },
  { ref: "G48", k: 'v', v: "", s: "e25" },
  { ref: "H48", k: 'v', v: "", s: "e26" },
  { ref: "I48", k: 'v', v: "", s: "e1" },
  { ref: "J48", k: 'lk', code: "", s: "e2" },
  { ref: "K48", k: 'v', v: "", s: "e26" },
  { ref: "L48", k: 'lk', code: "", s: "e27" },
  { ref: "A49", k: 'v', v: "DEPRECIACIÓN ACUMULADA DE EDIFICIOS", s: "e22" },
  { ref: "B49", k: 'v', v: "207104", s: "e13" },
  { ref: "C49", k: 'v', v: "", s: "e23" },
  { ref: "D49", k: 'lk', code: "207104", sign: -1, s: "e24" },
  { ref: "E49", k: 'v', v: "", s: "e13" },
  { ref: "F49", k: 'lk', code: "", s: "e24" },
  { ref: "G49", k: 'v', v: "PATRIMONIO COMPLEMENTARIO", s: "e25" },
  { ref: "H49", k: 'v', v: "302", s: "e26" },
  { ref: "I49", k: 'lk', code: "302", s: "e1" },
  { ref: "J49", k: 'v', v: "", s: "e2" },
  { ref: "K49", k: 'v', v: "", s: "e26" },
  { ref: "L49", k: 'lk', code: "", s: "e27" },
  { ref: "A50", k: 'v', v: "DEPRECIACIÓN ACUMULADA DE MOBILIARIO Y EQUIPO", s: "e22" },
  { ref: "B50", k: 'v', v: "207105", s: "e13" },
  { ref: "C50", k: 'v', v: "", s: "e23" },
  { ref: "D50", k: 'lk', code: "207105", sign: -1, s: "e24" },
  { ref: "E50", k: 'v', v: "", s: "e13" },
  { ref: "F50", k: 'lk', code: "", s: "e24" },
  { ref: "G50", k: 'v', v: "RESERVAS POR REVALUACIONES", s: "e25" },
  { ref: "H50", k: 'v', v: "302101", s: "e26" },
  { ref: "I50", k: 'v', v: "", s: "e1" },
  { ref: "J50", k: 'lk', code: "302101", s: "e2" },
  { ref: "K50", k: 'v', v: "", s: "e26" },
  { ref: "L50", k: 'lk', code: "", s: "e27" },
  { ref: "A51", k: 'v', v: "DEPRECIACIÓN ACUMULADA DE INSTALACIONES", s: "e22" },
  { ref: "B51", k: 'v', v: "207106", s: "e13" },
  { ref: "C51", k: 'v', v: "", s: "e23" },
  { ref: "D51", k: 'lk', code: "207106", sign: -1, s: "e24" },
  { ref: "E51", k: 'v', v: "", s: "e13" },
  { ref: "F51", k: 'lk', code: "", s: "e24" },
  { ref: "G51", k: 'v', v: "RESERVAS PARA CONTINGENCIAS", s: "e25" },
  { ref: "H51", k: 'v', v: "302102", s: "e26" },
  { ref: "I51", k: 'v', v: "", s: "e1" },
  { ref: "J51", k: 'lk', code: "302102", s: "e2" },
  { ref: "K51", k: 'v', v: "", s: "e26" },
  { ref: "L51", k: 'lk', code: "", s: "e27" },
  { ref: "A52", k: 'v', v: "DEPRECIACIÓN ACUMULADA DE ACTIVOS ARRENDADOS", s: "e22" },
  { ref: "B52", k: 'v', v: "207108", s: "e13" },
  { ref: "C52", k: 'v', v: "", s: "e23" },
  { ref: "D52", k: 'lk', code: "207108", sign: -1, s: "e24" },
  { ref: "E52", k: 'v', v: "", s: "e13" },
  { ref: "F52", k: 'lk', code: "", s: "e24" },
  { ref: "G52", k: 'v', v: "DONACIONES", s: "e25" },
  { ref: "H52", k: 'v', v: "302105", s: "e26" },
  { ref: "I52", k: 'v', v: "", s: "e1" },
  { ref: "J52", k: 'lk', code: "302105", s: "e2" },
  { ref: "K52", k: 'v', v: "", s: "e26" },
  { ref: "L52", k: 'lk', code: "", s: "e27" },
  { ref: "A53", k: 'v', v: "DEPRECIACION ACUMULADA DE VEHÍCULOS", s: "e22" },
  { ref: "B53", k: 'v', v: "207109", s: "e13" },
  { ref: "C53", k: 'v', v: "", s: "e23" },
  { ref: "D53", k: 'lk', code: "207109", sign: -1, s: "e24" },
  { ref: "E53", k: 'v', v: "", s: "e13" },
  { ref: "F53", k: 'lk', code: "", s: "e24" },
  { ref: "G53", k: 'v', v: "OTRAS RESERVAS DE CAPITAL", s: "e25" },
  { ref: "H53", k: 'v', v: "302107", s: "e26" },
  { ref: "I53", k: 'v', v: "", s: "e1" },
  { ref: "J53", k: 'lk', code: "302107", s: "e2" },
  { ref: "K53", k: 'v', v: "", s: "e26" },
  { ref: "L53", k: 'lk', code: "", s: "e27" },
  { ref: "A54", k: 'v', v: "", s: "e22" },
  { ref: "B54", k: 'v', v: "", s: "e13" },
  { ref: "C54", k: 'v', v: "", s: "e23" },
  { ref: "D54", k: 'lk', code: "", s: "e24" },
  { ref: "E54", k: 'v', v: "", s: "e13" },
  { ref: "F54", k: 'lk', code: "", s: "e24" },
  { ref: "G54", k: 'v', v: "RESULTADOS ACUMULADOS", s: "e25" },
  { ref: "H54", k: 'v', v: "302108", s: "e26" },
  { ref: "I54", k: 'v', v: "", s: "e1" },
  { ref: "J54", k: 'lk', code: "302108", s: "e2" },
  { ref: "K54", k: 'v', v: "", s: "e26" },
  { ref: "L54", k: 'lk', code: "", s: "e27" },
  { ref: "A55", k: 'v', v: "CARGOS DIFERIDOS", s: "e22" },
  { ref: "B55", k: 'v', v: "108", s: "e22" },
  { ref: "C55", k: 'f', f: "SUM(D56:D60)+SUM(F56:F60)", s: "e23" },
  { ref: "D55", k: 'v', v: "", s: "e24" },
  { ref: "E55", k: 'v', v: "", s: "e13" },
  { ref: "F55", k: 'lk', code: "", s: "e24" },
  { ref: "G55", k: 'v', v: "EXCEDENTES O PÉRDIDAS DEL PERIODO", s: "e25" },
  { ref: "H55", k: 'v', v: "302109", s: "e26" },
  { ref: "I55", k: 'v', v: "", s: "e1" },
  { ref: "J55", k: 'lk', code: "302109", s: "e2" },
  { ref: "K55", k: 'v', v: "", s: "e26" },
  { ref: "L55", k: 'lk', code: "", s: "e27" },
  { ref: "A56", k: 'v', v: "GASTOS PAGADOS POR ANTICIPADO", s: "e22" },
  { ref: "B56", k: 'v', v: "108101", s: "e13" },
  { ref: "C56", k: 'v', v: "", s: "e23" },
  { ref: "D56", k: 'lk', code: "108101", s: "e24" },
  { ref: "E56", k: 'v', v: "108201", s: "e13" },
  { ref: "F56", k: 'lk', code: "108201", s: "e24" },
  { ref: "G56", k: 'v', v: "", s: "e25" },
  { ref: "H56", k: 'v', v: "", s: "e26" },
  { ref: "I56", k: 'v', v: "", s: "e1" },
  { ref: "J56", k: 'lk', code: "", s: "e2" },
  { ref: "K56", k: 'v', v: "", s: "e26" },
  { ref: "L56", k: 'lk', code: "", s: "e27" },
  { ref: "A57", k: 'v', v: "INTERESES Y COMISIONES PAGADAS POR ANTICIPADO", s: "e22" },
  { ref: "B57", k: 'v', v: "108102", s: "e13" },
  { ref: "C57", k: 'v', v: "", s: "e23" },
  { ref: "D57", k: 'lk', code: "108102", s: "e24" },
  { ref: "E57", k: 'v', v: "108202", s: "e13" },
  { ref: "F57", k: 'lk', code: "108202", s: "e24" },
  { ref: "G57", k: 'v', v: "", s: "e25" },
  { ref: "H57", k: 'v', v: "", s: "e26" },
  { ref: "I57", k: 'v', v: "", s: "e1" },
  { ref: "J57", k: 'lk', code: "", s: "e2" },
  { ref: "K57", k: 'v', v: "", s: "e26" },
  { ref: "L57", k: 'lk', code: "", s: "e27" },
  { ref: "A58", k: 'v', v: "CUENTAS POR AMORTIZAR", s: "e22" },
  { ref: "B58", k: 'v', v: "108103", s: "e13" },
  { ref: "C58", k: 'v', v: "", s: "e23" },
  { ref: "D58", k: 'lk', code: "108103", s: "e24" },
  { ref: "E58", k: 'v', v: "", s: "e13" },
  { ref: "F58", k: 'lk', code: "", s: "e24" },
  { ref: "G58", k: 'v', v: "", s: "e25" },
  { ref: "H58", k: 'v', v: "", s: "e26" },
  { ref: "I58", k: 'v', v: "", s: "e1" },
  { ref: "J58", k: 'lk', code: "", s: "e2" },
  { ref: "K58", k: 'v', v: "", s: "e26" },
  { ref: "L58", k: 'lk', code: "", s: "e27" },
  { ref: "A59", k: 'v', v: "PAPELERÍA Y UTILES DE OFICINA", s: "e22" },
  { ref: "B59", k: 'v', v: "108104", s: "e13" },
  { ref: "C59", k: 'v', v: "", s: "e23" },
  { ref: "D59", k: 'lk', code: "108104", s: "e24" },
  { ref: "E59", k: 'v', v: "", s: "e13" },
  { ref: "F59", k: 'lk', code: "", s: "e24" },
  { ref: "G59", k: 'v', v: "", s: "e25" },
  { ref: "H59", k: 'v', v: "", s: "e26" },
  { ref: "I59", k: 'v', v: "", s: "e1" },
  { ref: "J59", k: 'lk', code: "", s: "e2" },
  { ref: "K59", k: 'v', v: "", s: "e26" },
  { ref: "L59", k: 'lk', code: "", s: "e27" },
  { ref: "A60", k: 'v', v: "OTROS CARGOS DIFERIDOS", s: "e22" },
  { ref: "B60", k: 'v', v: "108119", s: "e13" },
  { ref: "C60", k: 'v', v: "", s: "e23" },
  { ref: "D60", k: 'lk', code: "108119", s: "e24" },
  { ref: "E60", k: 'v', v: "108219", s: "e13" },
  { ref: "F60", k: 'lk', code: "108219", s: "e24" },
  { ref: "G60", k: 'v', v: "", s: "e25" },
  { ref: "H60", k: 'v', v: "", s: "e26" },
  { ref: "I60", k: 'v', v: "", s: "e1" },
  { ref: "J60", k: 'lk', code: "", s: "e2" },
  { ref: "K60", k: 'v', v: "", s: "e26" },
  { ref: "L60", k: 'lk', code: "", s: "e27" },
  { ref: "A61", k: 'v', v: "", s: "e22" },
  { ref: "B61", k: 'v', v: "", s: "e13" },
  { ref: "C61", k: 'v', v: "", s: "e23" },
  { ref: "D61", k: 'lk', code: "", s: "e24" },
  { ref: "E61", k: 'v', v: "", s: "e13" },
  { ref: "F61", k: 'lk', code: "", s: "e24" },
  { ref: "G61", k: 'v', v: "", s: "e25" },
  { ref: "H61", k: 'v', v: "", s: "e26" },
  { ref: "I61", k: 'v', v: "", s: "e1" },
  { ref: "J61", k: 'lk', code: "", s: "e2" },
  { ref: "K61", k: 'v', v: "", s: "e26" },
  { ref: "L61", k: 'lk', code: "", s: "e27" },
  { ref: "A62", k: 'v', v: "ACTIVOS DE INVERSIÓN", s: "e22" },
  { ref: "B62", k: 'v', v: "109", s: "e22" },
  { ref: "C62", k: 'f', f: "SUM(D63:D64)", s: "e23" },
  { ref: "D62", k: 'v', v: "", s: "e24" },
  { ref: "E62", k: 'v', v: "", s: "e13" },
  { ref: "F62", k: 'lk', code: "", s: "e24" },
  { ref: "G62", k: 'v', v: "", s: "e25" },
  { ref: "H62", k: 'v', v: "", s: "e26" },
  { ref: "I62", k: 'v', v: "", s: "e1" },
  { ref: "J62", k: 'lk', code: "", s: "e2" },
  { ref: "K62", k: 'v', v: "", s: "e26" },
  { ref: "L62", k: 'lk', code: "", s: "e27" },
  { ref: "A63", k: 'v', v: "Bienes Raíces", s: "e22" },
  { ref: "B63", k: 'v', v: "109101", s: "e13" },
  { ref: "C63", k: 'v', v: "", s: "e23" },
  { ref: "D63", k: 'lk', code: "109101", s: "e24" },
  { ref: "E63", k: 'v', v: "", s: "e13" },
  { ref: "F63", k: 'lk', code: "", s: "e24" },
  { ref: "G63", k: 'v', v: "", s: "e25" },
  { ref: "H63", k: 'v', v: "", s: "e26" },
  { ref: "I63", k: 'v', v: "", s: "e1" },
  { ref: "J63", k: 'lk', code: "", s: "e2" },
  { ref: "K63", k: 'v', v: "", s: "e26" },
  { ref: "L63", k: 'lk', code: "", s: "e27" },
  { ref: "A64", k: 'v', v: "AMORTIZACIÓN ACUMULADA DE ACTIVOS DE INVERSION", s: "e22" },
  { ref: "B64", k: 'v', v: "207110", s: "e13" },
  { ref: "C64", k: 'v', v: "", s: "e23" },
  { ref: "D64", k: 'lk', code: "207110", sign: -1, s: "e24" },
  { ref: "E64", k: 'v', v: "", s: "e13" },
  { ref: "F64", k: 'lk', code: "", s: "e24" },
  { ref: "G64", k: 'v', v: "", s: "e25" },
  { ref: "H64", k: 'v', v: "", s: "e26" },
  { ref: "I64", k: 'v', v: "", s: "e1" },
  { ref: "J64", k: 'lk', code: "", s: "e2" },
  { ref: "K64", k: 'v', v: "", s: "e26" },
  { ref: "L64", k: 'lk', code: "", s: "e27" },
  { ref: "A65", k: 'v', v: "", s: "e22" },
  { ref: "B65", k: 'v', v: "", s: "e13" },
  { ref: "C65", k: 'v', v: "", s: "e23" },
  { ref: "D65", k: 'lk', code: "", s: "e24" },
  { ref: "E65", k: 'v', v: "", s: "e13" },
  { ref: "F65", k: 'lk', code: "", s: "e24" },
  { ref: "G65", k: 'v', v: "", s: "e25" },
  { ref: "H65", k: 'v', v: "", s: "e26" },
  { ref: "I65", k: 'v', v: "", s: "e1" },
  { ref: "J65", k: 'lk', code: "", s: "e2" },
  { ref: "K65", k: 'v', v: "", s: "e26" },
  { ref: "L65", k: 'lk', code: "", s: "e27" },
  { ref: "A66", k: 'v', v: "ACTIVOS INTANGIBLES", s: "e22" },
  { ref: "B66", k: 'v', v: "110", s: "e22" },
  { ref: "C66", k: 'f', f: "SUM(D67:D69)+SUM(F67:F68)", s: "e23" },
  { ref: "D66", k: 'v', v: "", s: "e24" },
  { ref: "E66", k: 'v', v: "", s: "e13" },
  { ref: "F66", k: 'lk', code: "", s: "e24" },
  { ref: "G66", k: 'v', v: "", s: "e25" },
  { ref: "H66", k: 'v', v: "", s: "e26" },
  { ref: "I66", k: 'v', v: "", s: "e1" },
  { ref: "J66", k: 'lk', code: "", s: "e2" },
  { ref: "K66", k: 'v', v: "", s: "e26" },
  { ref: "L66", k: 'lk', code: "", s: "e27" },
  { ref: "A67", k: 'v', v: "PROGRAMAS Y APLICACIONES INFORMÁTICAS", s: "e22" },
  { ref: "B67", k: 'v', v: "110101", s: "e13" },
  { ref: "C67", k: 'v', v: "", s: "e23" },
  { ref: "D67", k: 'lk', code: "110101", s: "e24" },
  { ref: "E67", k: 'v', v: "110201", s: "e13" },
  { ref: "F67", k: 'lk', code: "110201", s: "e24" },
  { ref: "G67", k: 'v', v: "", s: "e25" },
  { ref: "H67", k: 'v', v: "", s: "e26" },
  { ref: "I67", k: 'v', v: "", s: "e1" },
  { ref: "J67", k: 'lk', code: "", s: "e2" },
  { ref: "K67", k: 'v', v: "", s: "e26" },
  { ref: "L67", k: 'lk', code: "", s: "e27" },
  { ref: "A68", k: 'v', v: "ACTIVO INTANGIBLE EN PROCESO", s: "e22" },
  { ref: "B68", k: 'v', v: "110102", s: "e13" },
  { ref: "C68", k: 'v', v: "", s: "e23" },
  { ref: "D68", k: 'lk', code: "110102", s: "e24" },
  { ref: "E68", k: 'v', v: "110202", s: "e13" },
  { ref: "F68", k: 'lk', code: "110202", s: "e24" },
  { ref: "G68", k: 'v', v: "", s: "e25" },
  { ref: "H68", k: 'v', v: "", s: "e26" },
  { ref: "I68", k: 'v', v: "", s: "e1" },
  { ref: "J68", k: 'lk', code: "", s: "e2" },
  { ref: "K68", k: 'v', v: "", s: "e26" },
  { ref: "L68", k: 'lk', code: "", s: "e27" },
  { ref: "A69", k: 'v', v: "AMORTIZACIÓN ACUMULADA DE ACTIVOS INTANGIBLES", s: "e22" },
  { ref: "B69", k: 'v', v: "207111", s: "e13" },
  { ref: "C69", k: 'v', v: "", s: "e23" },
  { ref: "D69", k: 'lk', code: "207111", sign: -1, s: "e24" },
  { ref: "E69", k: 'v', v: "", s: "e13" },
  { ref: "F69", k: 'lk', code: "", s: "e24" },
  { ref: "G69", k: 'v', v: "", s: "e25" },
  { ref: "H69", k: 'v', v: "", s: "e26" },
  { ref: "I69", k: 'v', v: "", s: "e1" },
  { ref: "J69", k: 'lk', code: "", s: "e2" },
  { ref: "K69", k: 'v', v: "", s: "e26" },
  { ref: "L69", k: 'lk', code: "", s: "e27" },
  { ref: "A70", k: 'v', v: "", s: "e22" },
  { ref: "B70", k: 'v', v: "", s: "e13" },
  { ref: "C70", k: 'v', v: "", s: "e23" },
  { ref: "D70", k: 'lk', code: "", s: "e24" },
  { ref: "E70", k: 'v', v: "", s: "e13" },
  { ref: "F70", k: 'lk', code: "", s: "e24" },
  { ref: "G70", k: 'v', v: "", s: "e32" },
  { ref: "H70", k: 'v', v: "", s: "e33" },
  { ref: "I70", k: 'v', v: "", s: "e34" },
  { ref: "J70", k: 'lk', code: "", s: "e35" },
  { ref: "K70", k: 'v', v: "", s: "e33" },
  { ref: "L70", k: 'lk', code: "", s: "e36" },
  { ref: "A71", k: 'v', v: "TOTAL ACTIVOS ", s: "e37" },
  { ref: "B71", k: 'v', v: "1", s: "e38" },
  { ref: "C71", k: 'f', f: "SUM(C13:C70)", s: "e39" },
  { ref: "D71", k: 'f', f: "SUM(D13:D70)", s: "e39" },
  { ref: "E71", k: 'v', v: "", s: "e39" },
  { ref: "F71", k: 'f', f: "SUM(F13:F70)", s: "e39" },
  { ref: "G71", k: 'v', v: "PASIVO + PATRIMONIO", s: "e11" },
  { ref: "H71", k: 'v', v: "", s: "e11" },
  { ref: "I71", k: 'f', f: "SUM(I13:I70)", s: "e39" },
  { ref: "J71", k: 'f', f: "SUM(J13:J70)", s: "e39" },
  { ref: "K71", k: 'v', v: "", s: "e39" },
  { ref: "L71", k: 'f', f: "SUM(L13:L70)", s: "e39" },
  { ref: "A72", k: 'v', v: "", s: "e17" },
  { ref: "B72", k: 'v', v: "", s: "e18" },
  { ref: "C72", k: 'v', v: "", s: "e19" },
  { ref: "D72", k: 'lk', code: "", s: "e20" },
  { ref: "E72", k: 'v', v: "", s: "e18" },
  { ref: "F72", k: 'lk', code: "", s: "e21" },
  { ref: "G72", k: 'v', v: "", s: "e17" },
  { ref: "H72", k: 'v', v: "", s: "e18" },
  { ref: "I72", k: 'v', v: "", s: "e19" },
  { ref: "J72", k: 'lk', code: "", s: "e20" },
  { ref: "K72", k: 'v', v: "", s: "e18" },
  { ref: "L72", k: 'lk', code: "", s: "e21" },
  { ref: "A73", k: 'v', v: "ACTIVOS CONTINGENTES", s: "e25" },
  { ref: "B73", k: 'v', v: "401", s: "e26" },
  { ref: "C73", k: 'lk', code: "401", s: "e1" },
  { ref: "D73", k: 'v', v: "", s: "e2" },
  { ref: "E73", k: 'v', v: "", s: "e26" },
  { ref: "F73", k: 'lk', code: "", s: "e27" },
  { ref: "G73", k: 'v', v: "PASIVOS CONTINGENTES", s: "e25" },
  { ref: "H73", k: 'v', v: "402", s: "e26" },
  { ref: "I73", k: 'lk', code: "402", s: "e1" },
  { ref: "J73", k: 'v', v: "", s: "e2" },
  { ref: "K73", k: 'v', v: "", s: "e26" },
  { ref: "L73", k: 'lk', code: "", s: "e27" },
  { ref: "A74", k: 'v', v: "CRÉDITOS POR UTILIZAR", s: "e25" },
  { ref: "B74", k: 'v', v: "401102", s: "e26" },
  { ref: "C74", k: 'v', v: "", s: "e1" },
  { ref: "D74", k: 'lk', code: "401102", s: "e2" },
  { ref: "E74", k: 'v', v: "401202", s: "e26" },
  { ref: "F74", k: 'lk', code: "401202", s: "e27" },
  { ref: "G74", k: 'v', v: "EXIGIBILIDADES CONTRACTUALES", s: "e25" },
  { ref: "H74", k: 'v', v: "402102", s: "e26" },
  { ref: "I74", k: 'v', v: "", s: "e1" },
  { ref: "J74", k: 'lk', code: "402102", s: "e2" },
  { ref: "K74", k: 'v', v: "402202", s: "e26" },
  { ref: "L74", k: 'lk', code: "402202", s: "e27" },
  { ref: "A75", k: 'v', v: "OPERACIONES DIVERSAS", s: "e25" },
  { ref: "B75", k: 'v', v: "401103", s: "e26" },
  { ref: "C75", k: 'v', v: "", s: "e1" },
  { ref: "D75", k: 'lk', code: "401103", s: "e2" },
  { ref: "E75", k: 'v', v: "401203", s: "e26" },
  { ref: "F75", k: 'lk', code: "401203", s: "e27" },
  { ref: "G75", k: 'v', v: "RESPONSABILIDADES DIVERSAS", s: "e25" },
  { ref: "H75", k: 'v', v: "402103", s: "e26" },
  { ref: "I75", k: 'v', v: "", s: "e1" },
  { ref: "J75", k: 'lk', code: "402103", s: "e2" },
  { ref: "K75", k: 'v', v: "402203", s: "e26" },
  { ref: "L75", k: 'lk', code: "402203", s: "e27" },
  { ref: "A76", k: 'v', v: "BALANCE", s: "e40" },
  { ref: "B76", k: 'v', v: "", s: "e33" },
  { ref: "C76", k: 'f', f: "SUM(C73:C75)", s: "e34" },
  { ref: "D76", k: 'f', f: "SUM(D73:D75)", s: "e34" },
  { ref: "E76", k: 'v', v: "", s: "e33" },
  { ref: "F76", k: 'f', f: "SUM(F73:F75)", s: "e41" },
  { ref: "G76", k: 'v', v: "", s: "e25" },
  { ref: "H76", k: 'v', v: "", s: "e26" },
  { ref: "I76", k: 'v', v: "", s: "e1" },
  { ref: "J76", k: 'lk', code: "", s: "e2" },
  { ref: "K76", k: 'v', v: "", s: "e26" },
  { ref: "L76", k: 'lk', code: "", s: "e27" },
  { ref: "A77", k: 'v', v: "", s: "e17" },
  { ref: "B77", k: 'v', v: "", s: "e18" },
  { ref: "C77", k: 'v', v: "", s: "e19" },
  { ref: "D77", k: 'lk', code: "", s: "e20" },
  { ref: "E77", k: 'v', v: "", s: "e18" },
  { ref: "F77", k: 'lk', code: "", s: "e21" },
  { ref: "G77", k: 'v', v: "", s: "e25" },
  { ref: "H77", k: 'v', v: "", s: "e26" },
  { ref: "I77", k: 'v', v: "", s: "e1" },
  { ref: "J77", k: 'lk', code: "", s: "e2" },
  { ref: "K77", k: 'v', v: "", s: "e26" },
  { ref: "L77", k: 'lk', code: "", s: "e27" },
  { ref: "A78", k: 'v', v: "CUENTAS DE ORDEN Y REGISTRO", s: "e42" },
  { ref: "B78", k: 'v', v: "7", s: "e26" },
  { ref: "C78", k: 'f', f: "C79+C82+C84+C91+C93+C95+C98+C100+C102", s: "e1" },
  { ref: "D78", k: 'v', v: "", s: "e2" },
  { ref: "E78", k: 'v', v: "", s: "e26" },
  { ref: "F78", k: 'v', v: "", s: "e27" },
  { ref: "G78", k: 'v', v: "", s: "e25" },
  { ref: "H78", k: 'v', v: "", s: "e26" },
  { ref: "I78", k: 'v', v: "", s: "e1" },
  { ref: "J78", k: 'lk', code: "", s: "e2" },
  { ref: "K78", k: 'v', v: "", s: "e26" },
  { ref: "L78", k: 'lk', code: "", s: "e27" },
  { ref: "A79", k: 'v', v: "VALORES Y BIENES CEDIDOS EN GARANTÍA", s: "e25" },
  { ref: "B79", k: 'v', v: "701", s: "e26" },
  { ref: "C79", k: 'lk', code: "701", s: "e1" },
  { ref: "D79", k: 'v', v: "", s: "e2" },
  { ref: "E79", k: 'v', v: "", s: "e26" },
  { ref: "F79", k: 'lk', code: "", s: "e27" },
  { ref: "G79", k: 'v', v: "CUENTAS DE ORDEN POR CONTRA", s: "e25" },
  { ref: "H79", k: 'v', v: "719", s: "e26" },
  { ref: "I79", k: 'lk', code: "719", s: "e1" },
  { ref: "J79", k: 'v', v: "", s: "e2" },
  { ref: "K79", k: 'v', v: "", s: "e26" },
  { ref: "L79", k: 'lk', code: "", s: "e27" },
  { ref: "A80", k: 'v', v: "PRÉSTAMOS OBTENIDOS DE INSTITUCIONES FINANCIERAS NACIONALES", s: "e25" },
  { ref: "B80", k: 'v', v: "701102", s: "e26" },
  { ref: "C80", k: 'v', v: "", s: "e1" },
  { ref: "D80", k: 'lk', code: "701102", s: "e2" },
  { ref: "E80", k: 'v', v: "701202", s: "e26" },
  { ref: "F80", k: 'lk', code: "701202", s: "e27" },
  { ref: "G80", k: 'v', v: "", s: "e25" },
  { ref: "H80", k: 'v', v: "", s: "e0" },
  { ref: "I80", k: 'v', v: "", s: "e1" },
  { ref: "J80", k: 'v', v: "", s: "e2" },
  { ref: "K80", k: 'v', v: "", s: "e0" },
  { ref: "L80", k: 'v', v: "", s: "e27" },
  { ref: "A81", k: 'v', v: "PRÉSTAMOS OBTENIDOS DE INSTITUCIONES INTERNACIONALES", s: "e25" },
  { ref: "B81", k: 'v', v: "701103", s: "e26" },
  { ref: "C81", k: 'v', v: "", s: "e1" },
  { ref: "D81", k: 'lk', code: "701103", s: "e2" },
  { ref: "E81", k: 'v', v: "701203", s: "e26" },
  { ref: "F81", k: 'lk', code: "701203", s: "e27" },
  { ref: "G81", k: 'v', v: "VALIDACIÓN DE CUENTAS DE ORDEN Y REGISTRO", s: "e25" },
  { ref: "H81", k: 'v', v: "719-7", s: "e26" },
  { ref: "I81", k: 'f', f: "I79-C78", s: "e1" },
  { ref: "J81", k: 'v', v: "", s: "e2" },
  { ref: "K81", k: 'v', v: "", s: "e0" },
  { ref: "L81", k: 'v', v: "", s: "e27" },
  { ref: "A82", k: 'v', v: "GARANTÍAS DE CRÉDITOS OTORGADOS", s: "e25" },
  { ref: "B82", k: 'v', v: "702", s: "e26" },
  { ref: "C82", k: 'lk', code: "702", s: "e1" },
  { ref: "D82", k: 'v', v: "", s: "e2" },
  { ref: "E82", k: 'v', v: "", s: "e26" },
  { ref: "F82", k: 'lk', code: "", s: "e27" },
  { ref: "G82", k: 'v', v: "", s: "e25" },
  { ref: "H82", k: 'v', v: "", s: "e0" },
  { ref: "I82", k: 'v', v: "", s: "e1" },
  { ref: "J82", k: 'v', v: "", s: "e2" },
  { ref: "K82", k: 'v', v: "", s: "e0" },
  { ref: "L82", k: 'v', v: "", s: "e27" },
  { ref: "A83", k: 'v', v: "VALORACIÓN DE GARANTÍAS", s: "e25" },
  { ref: "B83", k: 'v', v: "702106", s: "e26" },
  { ref: "C83", k: 'v', v: "", s: "e1" },
  { ref: "D83", k: 'lk', code: "702106", s: "e2" },
  { ref: "E83", k: 'v', v: "702206", s: "e26" },
  { ref: "F83", k: 'lk', code: "702206", s: "e27" },
  { ref: "G83", k: 'v', v: "", s: "e25" },
  { ref: "H83", k: 'v', v: "", s: "e0" },
  { ref: "I83", k: 'v', v: "", s: "e1" },
  { ref: "J83", k: 'v', v: "", s: "e2" },
  { ref: "K83", k: 'v', v: "", s: "e0" },
  { ref: "L83", k: 'v', v: "", s: "e27" },
  { ref: "A84", k: 'v', v: "CLASIFICACIÓN DE CARTERA CREDITICIA", s: "e25" },
  { ref: "B84", k: 'v', v: "703", s: "e26" },
  { ref: "C84", k: 'lk', code: "703", s: "e1" },
  { ref: "D84", k: 'v', v: "", s: "e2" },
  { ref: "E84", k: 'v', v: "", s: "e26" },
  { ref: "F84", k: 'lk', code: "", s: "e27" },
  { ref: "G84", k: 'v', v: "", s: "e25" },
  { ref: "H84", k: 'v', v: "", s: "e0" },
  { ref: "I84", k: 'v', v: "", s: "e1" },
  { ref: "J84", k: 'v', v: "", s: "e2" },
  { ref: "K84", k: 'v', v: "", s: "e0" },
  { ref: "L84", k: 'v', v: "", s: "e27" },
  { ref: "A85", k: 'v', v: "AGROPECUARIOS", s: "e25" },
  { ref: "B85", k: 'v', v: "703101", s: "e26" },
  { ref: "C85", k: 'v', v: "", s: "e1" },
  { ref: "D85", k: 'lk', code: "703101", s: "e2" },
  { ref: "E85", k: 'v', v: "", s: "e26" },
  { ref: "F85", k: 'lk', code: "", s: "e27" },
  { ref: "G85", k: 'v', v: "", s: "e25" },
  { ref: "H85", k: 'v', v: "", s: "e0" },
  { ref: "I85", k: 'v', v: "", s: "e1" },
  { ref: "J85", k: 'v', v: "", s: "e2" },
  { ref: "K85", k: 'v', v: "", s: "e0" },
  { ref: "L85", k: 'v', v: "", s: "e27" },
  { ref: "A86", k: 'v', v: "MICROCRÉDITO", s: "e25" },
  { ref: "B86", k: 'v', v: "703102", s: "e26" },
  { ref: "C86", k: 'v', v: "", s: "e1" },
  { ref: "D86", k: 'lk', code: "703102", s: "e2" },
  { ref: "E86", k: 'v', v: "", s: "e26" },
  { ref: "F86", k: 'lk', code: "", s: "e27" },
  { ref: "G86", k: 'v', v: "", s: "e25" },
  { ref: "H86", k: 'v', v: "", s: "e0" },
  { ref: "I86", k: 'v', v: "", s: "e1" },
  { ref: "J86", k: 'v', v: "", s: "e2" },
  { ref: "K86", k: 'v', v: "", s: "e0" },
  { ref: "L86", k: 'v', v: "", s: "e27" },
  { ref: "A87", k: 'v', v: "COMERCIALES", s: "e25" },
  { ref: "B87", k: 'v', v: "703103", s: "e26" },
  { ref: "C87", k: 'v', v: "", s: "e1" },
  { ref: "D87", k: 'lk', code: "703103", s: "e2" },
  { ref: "E87", k: 'v', v: "", s: "e26" },
  { ref: "F87", k: 'lk', code: "", s: "e27" },
  { ref: "G87", k: 'v', v: "", s: "e25" },
  { ref: "H87", k: 'v', v: "", s: "e0" },
  { ref: "I87", k: 'v', v: "", s: "e1" },
  { ref: "J87", k: 'v', v: "", s: "e2" },
  { ref: "K87", k: 'v', v: "", s: "e0" },
  { ref: "L87", k: 'v', v: "", s: "e27" },
  { ref: "A88", k: 'v', v: "CONSUMO", s: "e25" },
  { ref: "B88", k: 'v', v: "703104", s: "e26" },
  { ref: "C88", k: 'v', v: "", s: "e1" },
  { ref: "D88", k: 'lk', code: "703104", s: "e2" },
  { ref: "E88", k: 'v', v: "", s: "e26" },
  { ref: "F88", k: 'lk', code: "", s: "e27" },
  { ref: "G88", k: 'v', v: "", s: "e25" },
  { ref: "H88", k: 'v', v: "", s: "e0" },
  { ref: "I88", k: 'v', v: "", s: "e1" },
  { ref: "J88", k: 'v', v: "", s: "e2" },
  { ref: "K88", k: 'v', v: "", s: "e0" },
  { ref: "L88", k: 'v', v: "", s: "e27" },
  { ref: "A89", k: 'v', v: "DESTINO DE VIVIENDA", s: "e25" },
  { ref: "B89", k: 'v', v: "703105", s: "e26" },
  { ref: "C89", k: 'v', v: "", s: "e1" },
  { ref: "D89", k: 'lk', code: "703105", s: "e2" },
  { ref: "E89", k: 'v', v: "", s: "e26" },
  { ref: "F89", k: 'lk', code: "", s: "e27" },
  { ref: "G89", k: 'v', v: "", s: "e25" },
  { ref: "H89", k: 'v', v: "", s: "e0" },
  { ref: "I89", k: 'v', v: "", s: "e1" },
  { ref: "J89", k: 'v', v: "", s: "e2" },
  { ref: "K89", k: 'v', v: "", s: "e0" },
  { ref: "L89", k: 'v', v: "", s: "e27" },
  { ref: "A90", k: 'v', v: "VIVIENDA", s: "e25" },
  { ref: "B90", k: 'v', v: "703106", s: "e26" },
  { ref: "C90", k: 'v', v: "", s: "e1" },
  { ref: "D90", k: 'lk', code: "703106", s: "e2" },
  { ref: "E90", k: 'v', v: "", s: "e26" },
  { ref: "F90", k: 'lk', code: "", s: "e27" },
  { ref: "G90", k: 'v', v: "", s: "e25" },
  { ref: "H90", k: 'v', v: "", s: "e0" },
  { ref: "I90", k: 'v', v: "", s: "e1" },
  { ref: "J90", k: 'v', v: "", s: "e2" },
  { ref: "K90", k: 'v', v: "", s: "e0" },
  { ref: "L90", k: 'v', v: "", s: "e27" },
  { ref: "A91", k: 'v', v: "ADMINISTRACIÓN DE COBRANZA", s: "e25" },
  { ref: "B91", k: 'v', v: "705", s: "e26" },
  { ref: "C91", k: 'lk', code: "705", s: "e1" },
  { ref: "D91", k: 'v', v: "", s: "e2" },
  { ref: "E91", k: 'v', v: "", s: "e26" },
  { ref: "F91", k: 'lk', code: "", s: "e27" },
  { ref: "G91", k: 'v', v: "", s: "e25" },
  { ref: "H91", k: 'v', v: "", s: "e0" },
  { ref: "I91", k: 'v', v: "", s: "e1" },
  { ref: "J91", k: 'v', v: "", s: "e2" },
  { ref: "K91", k: 'v', v: "", s: "e0" },
  { ref: "L91", k: 'v', v: "", s: "e27" },
  { ref: "A92", k: 'v', v: "DOCUMENTOS Y VALORES", s: "e25" },
  { ref: "B92", k: 'v', v: "705101", s: "e26" },
  { ref: "C92", k: 'v', v: "", s: "e1" },
  { ref: "D92", k: 'lk', code: "705101", s: "e2" },
  { ref: "E92", k: 'v', v: "705201", s: "e26" },
  { ref: "F92", k: 'lk', code: "705201", s: "e27" },
  { ref: "G92", k: 'v', v: "", s: "e25" },
  { ref: "H92", k: 'v', v: "", s: "e0" },
  { ref: "I92", k: 'v', v: "", s: "e1" },
  { ref: "J92", k: 'v', v: "", s: "e2" },
  { ref: "K92", k: 'v', v: "", s: "e0" },
  { ref: "L92", k: 'v', v: "", s: "e27" },
  { ref: "A93", k: 'v', v: "OPERACIONES EN SUSPENSO", s: "e25" },
  { ref: "B93", k: 'v', v: "707", s: "e26" },
  { ref: "C93", k: 'lk', code: "707", s: "e1" },
  { ref: "D93", k: 'v', v: "", s: "e2" },
  { ref: "E93", k: 'v', v: "", s: "e26" },
  { ref: "F93", k: 'lk', code: "", s: "e27" },
  { ref: "G93", k: 'v', v: "", s: "e25" },
  { ref: "H93", k: 'v', v: "", s: "e0" },
  { ref: "I93", k: 'v', v: "", s: "e1" },
  { ref: "J93", k: 'v', v: "", s: "e2" },
  { ref: "K93", k: 'v', v: "", s: "e0" },
  { ref: "L93", k: 'v', v: "", s: "e27" },
  { ref: "A94", k: 'v', v: "INTERESES EN SUSPENSO SOBRE OPERACIONES CREDITICIAS", s: "e25" },
  { ref: "B94", k: 'v', v: "707101", s: "e26" },
  { ref: "C94", k: 'v', v: "", s: "e1" },
  { ref: "D94", k: 'lk', code: "707101", s: "e2" },
  { ref: "E94", k: 'v', v: "707201", s: "e26" },
  { ref: "F94", k: 'lk', code: "707201", s: "e27" },
  { ref: "G94", k: 'v', v: "", s: "e25" },
  { ref: "H94", k: 'v', v: "", s: "e0" },
  { ref: "I94", k: 'v', v: "", s: "e1" },
  { ref: "J94", k: 'v', v: "", s: "e2" },
  { ref: "K94", k: 'v', v: "", s: "e0" },
  { ref: "L94", k: 'v', v: "", s: "e27" },
  { ref: "A95", k: 'v', v: "CUENTAS DE ORDEN Y REGISTRO", s: "e25" },
  { ref: "B95", k: 'v', v: "708", s: "e26" },
  { ref: "C95", k: 'lk', code: "708", s: "e1" },
  { ref: "D95", k: 'v', v: "", s: "e2" },
  { ref: "E95", k: 'v', v: "", s: "e26" },
  { ref: "F95", k: 'lk', code: "", s: "e27" },
  { ref: "G95", k: 'v', v: "", s: "e25" },
  { ref: "H95", k: 'v', v: "", s: "e0" },
  { ref: "I95", k: 'v', v: "", s: "e1" },
  { ref: "J95", k: 'v', v: "", s: "e2" },
  { ref: "K95", k: 'v', v: "", s: "e0" },
  { ref: "L95", k: 'v', v: "", s: "e27" },
  { ref: "A96", k: 'v', v: "CUENTAS INCOBRABLES CASTIGADAS", s: "e25" },
  { ref: "B96", k: 'v', v: "708102", s: "e26" },
  { ref: "C96", k: 'v', v: "", s: "e1" },
  { ref: "D96", k: 'lk', code: "708102", s: "e2" },
  { ref: "E96", k: 'v', v: "708202", s: "e26" },
  { ref: "F96", k: 'lk', code: "708202", s: "e27" },
  { ref: "G96", k: 'v', v: "", s: "e25" },
  { ref: "H96", k: 'v', v: "", s: "e0" },
  { ref: "I96", k: 'v', v: "", s: "e1" },
  { ref: "J96", k: 'v', v: "", s: "e2" },
  { ref: "K96", k: 'v', v: "", s: "e0" },
  { ref: "L96", k: 'v', v: "", s: "e27" },
  { ref: "A97", k: 'v', v: "OTRAS CUENTAS DE ORDEN Y REGISTRO", s: "e25" },
  { ref: "B97", k: 'v', v: "708199", s: "e26" },
  { ref: "C97", k: 'v', v: "", s: "e1" },
  { ref: "D97", k: 'lk', code: "708199", s: "e2" },
  { ref: "E97", k: 'v', v: "708299", s: "e26" },
  { ref: "F97", k: 'lk', code: "708299", s: "e27" },
  { ref: "G97", k: 'v', v: "", s: "e25" },
  { ref: "H97", k: 'v', v: "", s: "e0" },
  { ref: "I97", k: 'v', v: "", s: "e1" },
  { ref: "J97", k: 'v', v: "", s: "e2" },
  { ref: "K97", k: 'v', v: "", s: "e0" },
  { ref: "L97", k: 'v', v: "", s: "e27" },
  { ref: "A98", k: 'v', v: "CRÉDITOS A PARTES RELACIONADAS", s: "e25" },
  { ref: "B98", k: 'v', v: "709", s: "e26" },
  { ref: "C98", k: 'lk', code: "709", s: "e1" },
  { ref: "D98", k: 'v', v: "", s: "e2" },
  { ref: "E98", k: 'v', v: "", s: "e26" },
  { ref: "F98", k: 'lk', code: "", s: "e27" },
  { ref: "G98", k: 'v', v: "", s: "e25" },
  { ref: "H98", k: 'v', v: "", s: "e0" },
  { ref: "I98", k: 'v', v: "", s: "e1" },
  { ref: "J98", k: 'v', v: "", s: "e2" },
  { ref: "K98", k: 'v', v: "", s: "e0" },
  { ref: "L98", k: 'v', v: "", s: "e27" },
  { ref: "A99", k: 'v', v: "CRÉDITOS OTORGADOS A PARTES RELACIONADAS", s: "e25" },
  { ref: "B99", k: 'v', v: "709101", s: "e26" },
  { ref: "C99", k: 'v', v: "", s: "e1" },
  { ref: "D99", k: 'lk', code: "709101", s: "e2" },
  { ref: "E99", k: 'v', v: "709201", s: "e26" },
  { ref: "F99", k: 'lk', code: "709201", s: "e27" },
  { ref: "G99", k: 'v', v: "", s: "e25" },
  { ref: "H99", k: 'v', v: "", s: "e0" },
  { ref: "I99", k: 'v', v: "", s: "e1" },
  { ref: "J99", k: 'v', v: "", s: "e2" },
  { ref: "K99", k: 'v', v: "", s: "e0" },
  { ref: "L99", k: 'v', v: "", s: "e27" },
  { ref: "A100", k: 'v', v: "PRÉSTAMOS REDESCONTADOS DE VIVIENDA", s: "e25" },
  { ref: "B100", k: 'v', v: "710", s: "e26" },
  { ref: "C100", k: 'lk', code: "710", s: "e1" },
  { ref: "D100", k: 'v', v: "", s: "e2" },
  { ref: "E100", k: 'v', v: "", s: "e26" },
  { ref: "F100", k: 'lk', code: "", s: "e27" },
  { ref: "G100", k: 'v', v: "", s: "e25" },
  { ref: "H100", k: 'v', v: "", s: "e0" },
  { ref: "I100", k: 'v', v: "", s: "e1" },
  { ref: "J100", k: 'v', v: "", s: "e2" },
  { ref: "K100", k: 'v', v: "", s: "e0" },
  { ref: "L100", k: 'v', v: "", s: "e27" },
  { ref: "A101", k: 'v', v: "PRÉSTAMOS REDESCONTADOS DE VIVIENDA CON HIPOTECA", s: "e25" },
  { ref: "B101", k: 'v', v: "710101", s: "e26" },
  { ref: "C101", k: 'v', v: "", s: "e1" },
  { ref: "D101", k: 'lk', code: "710101", s: "e2" },
  { ref: "E101", k: 'v', v: "710201", s: "e26" },
  { ref: "F101", k: 'lk', code: "710201", s: "e27" },
  { ref: "G101", k: 'v', v: "", s: "e25" },
  { ref: "H101", k: 'v', v: "", s: "e0" },
  { ref: "I101", k: 'v', v: "", s: "e1" },
  { ref: "J101", k: 'v', v: "", s: "e2" },
  { ref: "K101", k: 'v', v: "", s: "e0" },
  { ref: "L101", k: 'v', v: "", s: "e27" },
  { ref: "A102", k: 'v', v: "DOCUMENTOS Y VALORES EN CONSIGNACIÓN", s: "e25" },
  { ref: "B102", k: 'v', v: "711", s: "e26" },
  { ref: "C102", k: 'lk', code: "711", s: "e1" },
  { ref: "D102", k: 'v', v: "", s: "e2" },
  { ref: "E102", k: 'v', v: "", s: "e26" },
  { ref: "F102", k: 'lk', code: "", s: "e27" },
  { ref: "G102", k: 'v', v: "", s: "e25" },
  { ref: "H102", k: 'v', v: "", s: "e0" },
  { ref: "I102", k: 'v', v: "", s: "e1" },
  { ref: "J102", k: 'v', v: "", s: "e2" },
  { ref: "K102", k: 'v', v: "", s: "e0" },
  { ref: "L102", k: 'v', v: "", s: "e27" },
  { ref: "A103", k: 'v', v: "DOCUMENTOS Y VALORES EN CONSIGNACIÓN", s: "e32" },
  { ref: "B103", k: 'v', v: "711101", s: "e33" },
  { ref: "C103", k: 'v', v: "", s: "e34" },
  { ref: "D103", k: 'lk', code: "711101", s: "e35" },
  { ref: "E103", k: 'v', v: "711201", s: "e33" },
  { ref: "F103", k: 'lk', code: "711201", s: "e36" },
  { ref: "G103", k: 'v', v: "", s: "e32" },
  { ref: "H103", k: 'v', v: "", s: "e43" },
  { ref: "I103", k: 'v', v: "", s: "e34" },
  { ref: "J103", k: 'v', v: "", s: "e35" },
  { ref: "K103", k: 'v', v: "", s: "e43" },
  { ref: "L103", k: 'v', v: "", s: "e36" },
];
